import * as types from './fileActionTypes';

export default (
  state = {
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.UPLOAD_FILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case types.UPLOAD_FILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/file/fileReducer.js